import { get } from "../../root/modules/http/get.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { getRunningMode } from "./get-running-mode.js";

const checkVersionLog = log(loggingContexts.checkVersion);

export const checkVersion = async () => {
  const runningMode = getRunningMode();

  if (runningMode !== "production") {
    checkVersionLog.warn(
      "Alerter running in development mode. Version check skipped."
    );

    return;
  }

  checkVersionLog.info("checking latest version number");

  try {
    const response = await get(
      `${import.meta.env.VITE_APPLICATION_URL}/meta.json`
    ).json();

    checkVersionLog.info("meta.json", response);

    const currentVersion = localStorage.getItem("webVersion");

    const latestVersion = response.version;

    if (currentVersion !== response.version) {
      checkVersionLog.info("reloading application", {
        currentVersion,
        latestVersion,
      });

      location.reload();
    }
  } catch (error) {
    checkVersionLog.error(
      "error fetching meta.json",
      `${import.meta.env.VITE_APPLICATION_URL}/meta.json`
    );

    checkVersionLog.error(error);
  }
};
